<template>
  <m-btn
    class="view-toolbar-chip-trigger"
    :icon="icon"
    :color="color"
    :light="!hasValue"
    :clickable="clickable"
    small
    round
    icon-size="12"
  >
    <div class="_text">
      <slot />
    </div>
    <div
      v-if="!disabled"
      :style="{ marginLeft: '0.4rem' }"
    >
      <m-icon
        :class="['_suffix', !hasValue ? '-super-light': '']"
        type="down"
        size="12"
      />
    </div>
    <div
      v-if="hasUnsavedChanges"
      class="_dot"
    >
      <change-indicator />
    </div>
  </m-btn>
</template>
<script setup>
import ChangeIndicator from '@/components/list/ChangeIndicator.vue';
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    default: '',
  },
  hasValue: {
    type: Boolean,
    default: false,
  },
  hasUnsavedChanges: {
    type: Boolean,
    default: false,
  },
  clickable: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const color = computed(() => {
  if (props.hasValue) {
    return 'light-blue';
  }
  return '';
});
</script>
<style scoped lang="scss" type="text/scss">
.view-toolbar-chip-trigger {
  position: relative;

  ._text {
    max-width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ._suffix {
    &.-super-light {
      color: map_get($grey, 'lighten-2');
    }
  }

  ._dot {
    position: absolute;
    right: -.2rem;
    top: -.2rem;
  }
}
</style>
